<template>
    <div style="overflow-x: auto;">
        <vx-card style="background: #fff;box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);">
            <table style="width: 100%;">
                <tr>
                    <th class="border-table padding-th font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                        {{$t('course_id')}}
                    </th>
                    <th class="border-table padding-th font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                        {{$t('course_name')}}
                    </th>
                    <th class="border-table padding-th font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                        Cr
                    </th>
                    <th class="border-table padding-th font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                        {{$t('language')}}
                    </th>
                    <th class="border-table padding-th font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                        {{$t('type-load')}}
                    </th>
                    <th class="border-table padding-th font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                        Cr
                    </th>
                    <th class="border-table padding-th font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                        {{$t('auditorium')}}
                    </th>
                    <th class="border-table padding-th font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                        {{$t('weekday')}}
                    </th>
                    <th class="border-table padding-th font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                        {{$t('time')}}
                    </th>
                    <th class="border-table padding-th font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                        {{$t('Instructor')}}
                    </th>
                    <th class="border-table padding-th font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                        {{$t('format')}}
                    </th>
                    <th class="border-table padding-th font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                        {{$t('Section')}}
                    </th>
                    <th class="border-table padding-th font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                        {{$t('Exam')}}
                    </th>
                </tr>
                <template v-for="(study_year, index) in study_years">
                    <tr :key="'study_year_'+index">
                        <td colspan="13" class="border-table padding-th" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                            <b class="font-text">
                                {{ study_year.name }} {{ $t('study_year').toLowerCase() }}
                            </b>

                        </td>
                    </tr>
                    <template v-for="(semester, semester_index) in get_semester(study_year)">
                        <tr :key="'study_year_'+index + 'semester_'+semester_index">
                            <td colspan="13" class="border-table padding-th" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                                <b class="font-text">
                                    {{ semester.name }} {{ $t('semester').toLowerCase() }}
                                </b>
                            </td>
                        </tr>
                        <template v-for="(course, course_index) in get_course(study_year, semester)">
                            <tr :key="'study_year_'+index + 'semester_'+semester_index+'course_'+course_index">
                                <td class="border-table padding-th font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                                    {{ course.discipline?course.discipline.courseid:'-' }}
                                </td>
                                <td class="border-table padding-th font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                                    {{ course.discipline?course.discipline.name:'-' }}
                                    ({{ course.discipline?course.discipline.courseabbreviation:'' }})
                                </td>
                                <td class="border-table padding-th font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                                    {{ course.credit }}
                                </td>
                                <td class="border-table padding-th font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                                    {{ course.language?course.language.name:'-' }}
                                </td>
                                <td class="border-table font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                                    <Lesson :course="course">
                                        <template v-slot="{ item }">
                                            {{ item.lesson.load_type.name }}
                                        </template>
                                    </Lesson>
                                </td>
                                <td class="border-table font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                                    <Lesson :course="course">
                                        <template v-slot="{ item }">
                                            {{ item.lesson.credit }}
                                        </template>
                                    </Lesson>
                                </td>
                                <td class="border-table font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                                    <Lesson :course="course">
                                        <template v-slot="{ item }">
                                            {{ item.lesson.room?item.lesson.room.name:'-' }}
                                        </template>
                                    </Lesson>
                                </td>
                                <td class="border-table font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                                    <Lesson :course="course">
                                        <template v-slot="{ item }">
                                            {{ item.lesson.day_week?item.lesson.day_week.name:'-' }}
                                        </template>
                                    </Lesson>
                                </td>
                                <td class="border-table font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                                    <Lesson :course="course">
                                        <template v-slot="{ item }">
                                            {{ item.lesson.from_time?item.lesson.from_time.full_time:'-' }}
                                        </template>
                                    </Lesson>
                                </td>
                                <td class="border-table font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                                    <Lesson :course="course">
                                        <template v-slot="{ item }">
                                            {{ item.lesson.teacher?item.lesson.teacher.name_initial:'-' }}
                                        </template>
                                    </Lesson>
                                </td>
                                <td class="border-table font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                                    <Lesson :course="course">
                                        <template v-slot="{ item }">
                                            {{ item.lesson.flux.training_format?item.lesson.flux.training_format.name:'-' }}
                                        </template>
                                    </Lesson>
                                </td>
                                <td class="border-table font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                                    <Lesson :course="course">
                                        <template v-slot="{ item }">
                                            {{ item.lesson.flux.number_of_times_per_week }}
                                        </template>
                                    </Lesson>
                                </td>
                                <td class="border-table padding-th font-text" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                                    {{ course.control_form?course.control_form.name:'-' }}
                                </td>
                            </tr>
                        </template>
                        <tr :key="'study_year_'+index + 'semester_'+semester_index+'_total_credit'">
                            <td colspan="1" class="border-table padding-th" style="position: sticky; left: 0; z-index: 1; background-color: white;"/>
                            <td colspan="1" class="border-table padding-th" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                                <b class="font-text">
                                    {{ $t('total_credit_v2') }}
                                </b>
                            </td>
                            <td colspan="1" class="border-table padding-th" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                                {{ total_credit_semester(study_year, semester) }}
                            </td>
                            <td colspan="10" class="border-table padding-th" style="position: sticky; left: 0; z-index: 1; background-color: white;"/>
                        </tr>
                    </template>
                    <template>
                        <tr :key="'study_year_'+index + '_total_credit'">
                            <td colspan="1" class="border-table padding-th" style="position: sticky; left: 0; z-index: 1; background-color: white;"/>
                            <td colspan="1" class="border-table padding-th" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                                <b class="font-text">
                                    {{ $t('total_credit_v2_course') }}
                                </b>
                            </td>
                            <td colspan="1" class="border-table padding-th" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                                {{ total_credit_study_year(study_year) }}
                            </td>
                            <td colspan="10" class="border-table padding-th" style="position: sticky; left: 0; z-index: 1; background-color: white;"/>
                        </tr>
                    </template>
                </template>
                <tr :key="'total_credit_entire'">
                    <td colspan="1" class="border-table padding-th" style="position: sticky; left: 0; z-index: 1; background-color: white;"/>
                    <td colspan="1" class="border-table padding-th" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                        <b class="font-text">
                            {{ $t('total_credit_v2_entire') }}
                        </b>
                    </td>
                    <td colspan="1" class="border-table padding-th" style="position: sticky; left: 0; z-index: 1; background-color: white;">
                        {{ total_credit_entire() }}
                    </td>
                    <td colspan="10" class="border-table padding-th" style="position: sticky; left: 0; z-index: 1; background-color: white;"/>
                </tr>
            </table>
        </vx-card>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Lesson from "@/pages/Home/MyStudyPlan/Lesson";

export default {
    name: "StudyPlanApplications",
    components: { Lesson, },
    // async created() {
    //     await this.STUDY_PLAN_APPLICATIONS({...this.$route.query})
    // },
    methods:{
        ...mapActions({
            STUDY_PLAN_APPLICATIONS:'system_settings/STUDY_PLAN_APPLICATIONS',
        }),
        get_semester(study_year){
            let data = []
            this.GET_STUDY_PLAN_APPLICATIONS
                .filter(item=>item.lesson.flux.course.study_year.uid === study_year.uid)
                .forEach((item)=>{
                    let semester = item.lesson.flux.course.semester
                    let semester_find = data.filter(el=> el.uid === semester.uid)
                    if(semester_find.length === 0){
                        data.push(semester)
                    }
                })
            return data
        },
        total_credit_semester(study_year, semester){
            let total_credit = 0
            let data = this.get_course(study_year, semester)
            data.forEach(item=>total_credit+=item.credit)
            return total_credit
        },
        total_credit_study_year(study_year){
            let total_credit = 0
            let data = this.get_study_year_course(study_year)
            data.forEach(item=>total_credit+=item.credit)
            return total_credit
        },
        total_credit_entire(){
            let total_credit = 0
            let data = this.get_all_course()
            data.forEach(item=>total_credit+=item.credit)
            return total_credit
        },
        get_course(study_year, semester){
            let data = []
            this.GET_STUDY_PLAN_APPLICATIONS
                .filter(
                    item=>
                        item.lesson.flux.course.study_year.uid === study_year.uid &&
                        item.lesson.flux.course.semester.uid === semester.uid
                )
                .forEach((item)=>{
                    let course = item.lesson.flux.course
                    let course_find = data.filter(el=> el.uid === course.uid)
                    if(course_find.length === 0){
                        data.push(course)
                    }
                })

            return data
        },
        get_all_course(){
            let data = []
            this.GET_STUDY_PLAN_APPLICATIONS
                .forEach((item)=>{
                    let course = item.lesson.flux.course
                    let course_find = data.filter(el=> el.uid === course.uid)
                    if(course_find.length === 0){
                        data.push(course)
                    }
                })

            return data
        },
        get_study_year_course(study_year){
            let data = []
            this.GET_STUDY_PLAN_APPLICATIONS
                .filter(
                    item=>
                        item.lesson.flux.course.study_year.uid === study_year.uid
                )
                .forEach((item)=>{
                    let course = item.lesson.flux.course
                    let course_find = data.filter(el=> el.uid === course.uid)
                    if(course_find.length === 0){
                        data.push(course)
                    }
                })

            return data
        },
    },
    computed:{
        ...mapGetters({
            GET_STUDY_PLAN_APPLICATIONS:'system_settings/GET_STUDY_PLAN_APPLICATIONS',
        }),
        study_years(){
            let data = []
            this.GET_STUDY_PLAN_APPLICATIONS.forEach((item)=>{
                let study_year = item.lesson.flux.course.study_year
                let study_year_find = data.filter(el=> el.uid === study_year.uid)
                if(study_year_find.length === 0){
                    data.push(study_year)
                }
            })
            data.sort(function(a, b) {
                return a.start - b.start;
            });
            return data
        },

    },

};
</script>

<style scoped>
.border-table{
    border: 2px solid #f2f2f8;
}
.padding-th{
    padding: 20px 10px;
}
.font-text{
    font-family: "Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
    font-size: 15px;
}
</style>
